import { ExternalRouter } from 'src/lib/external-router';

import Config from '../config';

const { communityUrl } = Config;

export const CommunityRouter = new ExternalRouter(communityUrl, {
  Home: '',
});
